import { Injectable } from '@angular/core';
import { GlobalSelectionControlService } from '../map/services/global-selection-control.service';
import { ConfigurationConstants, FeatureType } from '../models/EnumTypes';
import { FomCheckModel } from '../models/fom-check';
import { NavaidModel } from '../models/navaid';
import { ModalControlService } from './modal-control.service';
import { PointsService } from './points.service';

@Injectable({
  providedIn: 'root'
})
export class FomCheckService {

  public active: boolean;
  public model : FomCheckModel;
  public fullScreenMode:boolean = false;

  constructor(private pointsService : PointsService,
    private globalSelectionService : GlobalSelectionControlService,
    private modalService : ModalControlService) { }

  switchFooter(){
    this.active  = true;
  }
  closeFooter(){
    this.active = false;
  }
  openFomCheck() : boolean {
    this.model = new FomCheckModel();
    let navaidsToCheck : NavaidModel[] = [];
    this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid).forEach(navaid => {
      navaidsToCheck.push(this.pointsService.transformFeatureInNavaid(navaid));
    });
    if(navaidsToCheck.length == 0){
      navaidsToCheck = this.pointsService.getAllNavaidsFromLayers();
    }
    navaidsToCheck.forEach(navaid => {
      if(!this.isValidFomDOC(navaid)){
        this.model.navaids.push(navaid);
      }
    });
    if(this.model.navaids.length > 0){
      this.fixFOMColumn();
      this.switchFooter();
      return true;
    }
    else{
      this.modalService.showMesssageModal("FOM Check", "There are no NavAids to display!");
      return false;
    }
  }

  private fixFOMColumn(): void {
    this.model.navaids.forEach(navaid => {
      navaid.arinc424fom = navaid.arinc424fom
        .replace("TERMINAL_USE","0: DOC < 25[NM] - ALTITUDE < 12000[FT]")
        .replace("LOW_ALTITUDE_USE","1: DOC < 40[NM] - ALTITUDE < 18000[FT]")
        .replace("HIGH_ALTITUDE","2: DOC < 130[NM] - ALTITUDE < 60000[FT]")
        .replace("EXTENDED_HIGH_ALTITUDE","3: DOC > 130[NM]")
        .replace("NOT_INCLUDED","7: NOT INCLUDED")
        .replace("OUT_OF_SERVICE","9: OUT OF SERVICE")
    });
  }

  private isValidFomDOC(navaid : NavaidModel): boolean {
		let maxDoc : number = 0;
		if(navaid.arinc424fom != null){
			maxDoc = ConfigurationConstants.getMaxDocArincFOM(navaid.arinc424fom);
			if (navaid.doc == null) {
				return true;
			}
			if(parseFloat(navaid.doc) <= maxDoc){
				return true;
			} else {
				return false;
			}
		}
		else{
			return true;
		}
	}
}
